module.exports = __webpack_public_path__ + "static/media/corporativo.7b02febf.png";